export default __webpack_public_path__ + "static/backgroundImage-fee996d1ce2a9358b7ed73d267818645.jpg";